import { shallowReactive, ComputedRef, computed } from 'vue';
import {
    IManagerCallback,
    ILocationType,
    ExternalSourceOption,
} from "./LocationFinderTypes"

import { UrlContentToDataUri } from "./locationHelpers";

export class LocationTypeManager {
    public InternalSource: ILocationType[];
    public ExternalSource: ILocationType[];
    public ExternalSharedBranch?: ILocationType;
    public ExternalAtm?: ILocationType;
    public Counter: number;

    constructor(locationTypes: ILocationType[], isExternalSourceEnabled = false) {
        this.ExternalSource = []
        this.InternalSource = []
        this.Counter = 0;

        if (locationTypes) {
            this.InternalSource = locationTypes
                .filter(elm => elm.ExternalSource == ExternalSourceOption.None)
                .map(item => {
                    if (item.ImageUrl && item.ImageUrl != "") {
                        UrlContentToDataUri(item.ImageUrl)
                            .then(dataUrl => {
                                this.InternalSource = this.InternalSource.map(elm => {
                                    if (elm.Id == item.Id) {
                                        return ({
                                            ...elm,
                                            Base64Icon: dataUrl
                                        })
                                    }
                                    return elm
                                })
                            });
                    }
                    return {
                        Selected: true,
                        ...item
                    }
                })
        }

        if (locationTypes && isExternalSourceEnabled) {
            const sharedBranch = locationTypes.find(elm => elm.ExternalSource == ExternalSourceOption.SharedBranches)
            const atm = locationTypes.find(elm => elm.ExternalSource == ExternalSourceOption.ATMs)

            if (typeof sharedBranch != 'undefined') {

                this.ExternalSharedBranch = {
                    ...sharedBranch,
                    Id: "SHAREDBRANCH",
                    Selected: true,
                    Base64Icon: "",
                }
                this.ExternalSource.push(this.ExternalSharedBranch)

                if (sharedBranch.ImageUrl && sharedBranch.ImageUrl != "") {
                    UrlContentToDataUri(sharedBranch.ImageUrl)
                        .then((dataUrl: string) => {
                            this.ExternalSource = this.ExternalSource.map(elm => {
                                if (elm.Id == "SHAREDBRANCH") {
                                    return ({
                                        ...elm,
                                        Base64Icon: dataUrl
                                    })
                                }
                                return elm
                            })
                            if (this.ExternalSharedBranch) this.ExternalSharedBranch.Base64Icon = dataUrl;
                        });
                }
            }

            if (typeof atm != 'undefined') {

                this.ExternalAtm = {
                    ...atm,
                    Id: "ATM",
                    Selected: true,
                    Base64Icon: "",
                }

                this.ExternalSource.push(this.ExternalAtm)

                if (atm.ImageUrl && atm.ImageUrl != "") {
                    UrlContentToDataUri(atm.ImageUrl)
                        .then(dataUrl => {
                            this.ExternalSource = this.ExternalSource.map(elm => {
                                if (elm.Id == "ATM") {
                                    return ({
                                        ...elm,
                                        Base64Icon: dataUrl
                                    })
                                }
                                return elm
                            })
                            if (this.ExternalAtm) this.ExternalAtm.Base64Icon = dataUrl;
                        });
                }
            }
        }
    }

    public GetInternalLocationTypeFromId(id: string) {
        return this.InternalSource.find(elm => elm.Id == id)
    }

    public IsSharedBranchSelected() {
        const sb = this.ExternalSource.find(elm => elm.Id == "SHAREDBRANCH")
        if (typeof sb == "undefined") return false
        return sb.Selected
    }

    public IsAtmSelected() {
        const atm = this.ExternalSource.find(elm => elm.Id == "ATM")
        if (typeof atm == "undefined") return false
        return atm.Selected
    }

    public IsAnyInternalSourceSelected() {
        return (this.InternalSource.filter(elm => elm.Selected).length > 0)
    }

    public IsAnyExternalSourceSelected() {
        return (this.ExternalSource.filter(elm => elm.Selected).length > 0)
    }

    public ToggleInternalSource(id: string, callback?: IManagerCallback<LocationTypeManager>) {
        this.InternalSource = this.InternalSource.map(elm => elm.Id == id ? { ...elm, Selected: !elm.Selected } : elm)
        if (callback) callback(this);
    }

    public ToggleExternalSource(id: string, callback?: IManagerCallback<LocationTypeManager>) {
        this.ExternalSource = this.ExternalSource.map(elm => elm.Id == id ? { ...elm, Selected: !elm.Selected } : elm)
        if (callback) callback(this);
    }
}

export default function GetLocationTypeManager(locationTypes: ILocationType[], isExternalSourceEnable: boolean) {
    return shallowReactive(new LocationTypeManager(locationTypes, isExternalSourceEnable))
}
